import { Component } from "@angular/core";
import { MdDialog, MdDialogRef } from "@angular/material";
import { AddEditFaqComponent } from "./add-edit-faq/add-edit-faq.component";
import { LicenseService } from "../../services/LicenseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import { ExportToCSVService } from "../../services/ExportToCSVService";
import Swal from "sweetalert2";
import { FAQDetail, ImportFaqComponent } from "./import-faq/import-faq.component";
import { DialogInjector } from "@angular/material/dialog/dialog-injector";
import { AdalService } from "../../shared/adal.service";
import { Router } from "@angular/router";
import { PagerService } from "../../services/PagerService";
import { LicenseModuleGltComponent } from "../glt/glt.component";
import { LicensePortalProduct } from "../../interfaces/LicenseModel";

@Component({
    selector:'faq',
    template:require('./faq.component.html'),
    styles:[require('./faq.component.css')]
    
})
export class FaqComponent{
    dialogTitle="FAQ";
    errorMessage=""
    uploadResponse='';
    faqDisplayDetail;
    pager:any={};
    pagedItems=[];
    constructor(
        private dialog:MdDialog,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private exportService:ExportToCSVService,
        private adalService:AdalService,
        private router:Router,
        private pagerService:PagerService,
    ){
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(["login"]);
        }
        else{
            this.getFaq();
        }
    }
    addFaq(){
        let addFaqDialogRef:MdDialogRef<AddEditFaqComponent>=this.dialog.open(AddEditFaqComponent,{
            width:'40%',
            data:{
                FaqDisplayDetail:this.faqDisplayDetail,
                SelectedFAQDetail:null
            },
            disableClose:true
        })
        addFaqDialogRef.afterClosed().subscribe((result)=>{
            this.faqDisplayDetail=result;
            this.setPage(1);
        })
    }
    editFaq(row){
        let editFaqDialogRef:MdDialogRef<AddEditFaqComponent>=this.dialog.open(AddEditFaqComponent,{
            width:'40%',
            data:{
                FaqDisplayDetail:this.faqDisplayDetail,
                SelectedFAQDetail:row
            },
            disableClose:true
        });
        editFaqDialogRef.afterClosed().subscribe((result)=>{
            this.faqDisplayDetail=result;
            this.setPage(this.pager.currentPage);
        })
    }
    deleteFaq(row){
        Swal.fire({
            title:'Delete FAQ',
            text:'Are you sure you want to delete the FAQ?',
            showCancelButton:true,
            showConfirmButton:true,
            showCloseButton:true,
            cancelButtonText:'No',
            confirmButtonText:'Yes',
            confirmButtonColor:'#FFCA28'
        }).then((result)=>{
            if(result.isConfirmed){
                this.appLoader.open()
                this.licenseService.deleteFAQ(row.FAQId,Number(localStorage.getItem('userid'))).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        this.faqDisplayDetail=data.DataObject;
                        this.setPage(this.pager.currentPage);
                    }
                    this.appLoader.close()
                })
            }
        })
    }
    importFaq(){
        let importFaqDialogComponent:MdDialogRef<ImportFaqComponent>=this.dialog.open(ImportFaqComponent,{
            width:'50%',
            height:'70%',
            data:{
                FaqDisplayDetail:this.faqDisplayDetail,
            },
            disableClose:true
        })
        importFaqDialogComponent.afterClosed().subscribe((result)=>{
            this.faqDisplayDetail=result;
            this.setPage(1);
        })
    }
    setPage(page: number) {
        this.pager = this.pagerService.getPager(this.faqDisplayDetail.length, page);
        this.pagedItems = this.faqDisplayDetail.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    getFaq(){
        this.appLoader.open()
        this.licenseService.getFAQWithProductId(LicensePortalProduct.LZ30).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.faqDisplayDetail=data.DataObject;
                this.setPage(1);
            }
            this.appLoader.close()
        })
    }
    downloadCsv(){
        let jsonData:Array<any>=[];
        this.faqDisplayDetail.forEach(element => {
            jsonData.push({
                Question:element.Question,
                Answer:element.Answer,
            })
        });
        this.exportService.exportToCsv(jsonData,'FAQ')
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/faq/faq.component.ts